/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharp_Green_Eagle_SlipInputs */

const en_sharp_green_eagle_slip = /** @type {(inputs: Sharp_Green_Eagle_SlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language Settings`)
};

const de_sharp_green_eagle_slip = /** @type {(inputs: Sharp_Green_Eagle_SlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spracheinstellungen`)
};

/**
* | output |
* | --- |
* | "Language Settings" |
*
* @param {Sharp_Green_Eagle_SlipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sharp_green_eagle_slip = /** @type {((inputs?: Sharp_Green_Eagle_SlipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharp_Green_Eagle_SlipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharp_green_eagle_slip(inputs)
	return de_sharp_green_eagle_slip(inputs)
});